import { LoginPage } from "routes/login/LoginPage";
import { RouteConfig } from "./routeTypes";
import { VerifyEmailPage } from "routes/verify-email/VerifyEmailPage";
import { AssistantPage } from "pages/assistant/AssistantPage";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { JwtRequiredPage } from "routes/jwt-auth/JwtRequiredPage";

export const RedirectToAssistant = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/assistant", { replace: true });
  }, [navigate]);

  return null; // Don't render anything, this is just for redirect
};
export const guestRouteConfig: RouteConfig[] = [
  {
    path: "/",
    component: LoginPage,
  },
  {
    path: "/jwt-auth-required",
    component: JwtRequiredPage,
  },
];

export const publicRouteConfig: RouteConfig[] = [
  {
    path: "/verify-email",
    component: VerifyEmailPage,
  },
];

export const protectedRouteConfig: RouteConfig[] = [
  {
    path: "/assistant",
    component: AssistantPage,
    subscriptionOnly: true,
  },
  {
    path: "/assistant/:threadId",
    component: AssistantPage,
    subscriptionOnly: true,
  },
];

export const combinedRouteConfig = [
  ...guestRouteConfig,
  ...publicRouteConfig,
  ...protectedRouteConfig,
];
